import api from '../../../auth/apiClient';
import { getFuelConsumptionEndpoint } from '../apiConfig';
import type { FuelConsumptionResponse, FuelConsumptionFilters } from '../types';

export class FuelConsumptionService {
    static async getVsLacak(filters: FuelConsumptionFilters): Promise<FuelConsumptionResponse> {
        const endpoint = getFuelConsumptionEndpoint('VS_LACAK');
        const response = await api.get<FuelConsumptionResponse>(endpoint, {
            params: filters,
        });
        return response.data;
    }
}
